import MainCompliance from "../components/compliance-component/main-compliance";

function Compliance() {
  return (
    <div className="w-[95%] mx-auto">
        
      <MainCompliance />
    </div>
  );
}

export default Compliance;